import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import PageSwiperStore from '@src/components/swiper/page-swiper/store';
import useModal from '@src/utils/hooks/use-modal';
import AppointmentModal from '@src/business-components/appointment-modal';
import AppointmentModalStore from '@src/business-components/appointment-modal/store';
import AppointmentSuccessModal from '@src/business-components/appointment-success-modal';
import AppointmentSuccessModalStore from '@src/business-components/appointment-success-modal/store';
import MainKvStore from './components/main-kv/store';
import NewsStore from './components/news/store';
import FeatureStore from './components/feature/store';
import ClanStore from './components/clan/store';
import StrategyStore from './components/strategy/store';
import AuditionStore from './components/audition/store';
import FollowUsStore from './components/follow-us/store';
import CommonHeaderStore from '@src/business-components/common-header/store';
import FloatRightStore from '@src/pages/float-right/store';
import { observable } from 'mobx';
import { useEffect } from 'react';
import { getParameterByNames } from '@src/utils/device';
import { getOmniData } from '@src/services/omni-api';
import { DOWNLOAD_QR_POSITION, getDownloadQrIframeUrl } from '@src/utils/qr-track-iframe';
import { createCustomDownloadDataSources, createDownloadDataSources, getDownloadLinks } from '@src/utils/download-data';
import $$tracker from '@src/tracker';
// import { injectFooterAssets } from '@src/utils/injection-footer';

class MainStore extends BaseStore {
  pageSwiperStore = new PageSwiperStore();
  appointmentModalStore = new AppointmentModalStore();
  appointmentSuccessModalStore = new AppointmentSuccessModalStore();
  commonHeaderStore = new CommonHeaderStore({
    changeSwiperCallback: (id, type) => {
      this.changeSwiperCallback(id, type);
    }
  });
  mainKvStore = new MainKvStore();
  newsStore = new NewsStore();
  featureStore = new FeatureStore();
  clanStore = new ClanStore();
  strategyStore = new StrategyStore();
  auditionStore = new AuditionStore();
  followUsStore = new FollowUsStore();
  floatRightStore = new FloatRightStore({
    backToTop: () => this.pageSwiperStore.baseSwiperStore.onChange(0)
  });
  @observable device_id = '';
  @observable config = {};
  @observable isHarmonyDownloadModalOpen = false;
  @observable
  kvIds = {
    // ds_cat_eee26b99: 'KV',
    // ds_cat_8f98015d: '游戏阶段信息',
    // ds_cat_64422aa5: '下载渠道配置-自定义渠道',
    // ds_cat_aa5b92de: '下载渠道配置-默认渠道'
    kv: 'ds_cat_eee26b99',
    stage: 'ds_cat_8f98015d',
    custom_download: 'ds_cat_64422aa5',
    default_download: 'ds_cat_aa5b92de'
  };

  @observable swiper = ['mainKvStore', 'newsStore', 'featureStore', 'clanStore', 'strategyStore', 'auditionStore', 'followUsStore'];

  openAppointmentModal = (type = 1) => {
    if (type === 1) {
      $$tracker.clickToReserve();
    }
    this.appointmentModalStore.type = type;
    this.appointmentModalStore.device_id = this.device_id;
    this.appointmentModalStore.isOpen = true;
    this.modals.appointmentModal.open();
    this.appointmentModalStore.successCallback = type => {
      this.getConfig();
      this.getSubscribeCount();
      this.openAppointmentSuccessModal(type);
    };
  };
  openAppointmentSuccessModal = (type = 1) => {
    this.appointmentSuccessModalStore.type = type;
    this.appointmentSuccessModalStore.isOpen = true;
    this.modals.appointmentSuccessModal.open();
  };

  openHarmonyDownloadModal = () => {
    this.isHarmonyDownloadModalOpen = true;
  };

  closeHarmonyDownloadModal = () => {
    this.isHarmonyDownloadModalOpen = false;
  };

  /**
   * 获取预约人数
   */
  getSubscribeCount = () => {
    this.$ztService
      .getSubscribeCount()
      .then(res => {
        this.mainKvStore.subscribeTotal = res.subscribe_total;
      })
      .catch(err => {
        console.log(err);
      });
  };

  generateDeviceId = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  init = () => {
    this.device_id = localStorage.getItem('device_id') || this.generateDeviceId();
    localStorage.setItem('device_id', this.device_id);
  };

  setFooterVisible = visible => {
    this.pageSwiperStore.stopScroll = visible;
  };

  setSwiperDefaultIndex = () => {
    const currentPage = getParameterByNames('currentPage');
    if (currentPage) {
      this.pageSwiperStore.baseSwiperStore.onChange(currentPage);
      let url = window.location.href;
      let newUrl = url.replace(`?currentPage=${currentPage}`, '');
      window.history.replaceState({}, document.title, newUrl);
    }
  };

  getConfig = () => {
    this.$ztService
      .getConfig()
      .then(res => {
        this.config = res;
        this.mainKvStore.config = res;
        this.mainKvStore.openAppointmentModal = () => {
          if (this.config.phone) {
            this.openAppointmentSuccessModal();
          } else {
            this.openAppointmentModal();
          }
        };
      })
      .catch(err => {
        console.log(err);
      });
  };

  getKvData = async () => {
    try {
      const utmSource = (getParameterByNames('utm_source') || '').trim();
      const dataSources = createDownloadDataSources(this.kvIds);
      const customDataSources = createCustomDownloadDataSources(this.kvIds, utmSource);
      let customDownloadRequest = Promise.resolve({});
      if (customDataSources.length) {
        customDownloadRequest = getOmniData('channel_cat_8ae9f08e', customDataSources).catch(error => {
          console.warn('获取 Omni 渠道下载数据失败，已回退默认官包', error);
          return {};
        });
      }
      const [res, customDownloadRes] = await Promise.all([getOmniData('channel_cat_8ae9f08e', dataSources), customDownloadRequest]);

      // 设置首屏KV数据 ds_cat_eee26b99
      const kvData = res?.[this.kvIds.kv]?.result?.items || [];
      const kvInfo = {
        kv: kvData?.[0]?.kv_image?.[0]?.url || '',
        kv_video: kvData?.[0]?.kv_video?.[0]?.url || '',
        video: kvData?.[0]?.homepage_kv?.[0]?.url || '',
        play_bg_img: kvData?.[0]?.play_bg_img?.[0]?.url || '',
        slogan: kvData?.[0]?.slogan?.[0]?.url || '',
        // template: 'mid'
        template: kvData?.[0]?.template || ''
      };
      this.mainKvStore.kvInfo = kvInfo;

      // 设置游戏阶段
      const stage = res?.[this.kvIds.stage]?.result?.items?.[0];
      if (stage) {
        const gameStage = stage.game_stage_config || 'appointment';
        this.mainKvStore.stage = gameStage;
        this.floatRightStore.type = gameStage === 'appointment' ? 1 : 2;
      }

      // 处理下载数据
      const download = res?.[this.kvIds.default_download]?.result?.items || [];
      const utmInfo = customDownloadRes?.[this.kvIds.custom_download]?.result?.items || [];
      const downloadUrl = getDownloadLinks(download, utmInfo, utmSource);

      downloadUrl.indexQrcode = getDownloadQrIframeUrl(downloadUrl.qrcode, DOWNLOAD_QR_POSITION.HOME);
      downloadUrl.floatQrcode = getDownloadQrIframeUrl(downloadUrl.qrcode, DOWNLOAD_QR_POSITION.HOME_SIDE);

      // 为浮窗位置赋值
      this.mainKvStore.downloadUrl = downloadUrl;
      this.floatRightStore.downloadUrl = downloadUrl;
    } catch (error) {
      console.log(error);
    }
  };

  changeSwiperCallback = id => {
    // 顶部导航统一使用锚点(分屏滚动)方式定位, 攻略资料不再单独跳转列表页
    this.pageSwiperStore.baseSwiperStore.onChange(id);
  };

  use() {
    super.use();
    this.modals = {
      appointmentModal: useModal(AppointmentModal, { store: this.appointmentModalStore }),
      appointmentSuccessModal: useModal(AppointmentSuccessModal, { store: this.appointmentSuccessModalStore })
    };
    useMount(async () => {
      // TODO 切换到指定模块，用于开发
      // this.pageSwiperStore.baseSwiperStore.onChange(4);
      this.getConfig();
      this.getSubscribeCount();
      this.init();
      this.setSwiperDefaultIndex();
      this.getKvData();
    });

    useEffect(
      () => {
        if (this.pageSwiperStore.baseSwiperStore.activeIndex === 0) {
          this.commonHeaderStore.isMax = false;
        } else {
          this.commonHeaderStore.isMax = true;
        }
        this.commonHeaderStore.setCurrent(this.pageSwiperStore.baseSwiperStore.activeIndex);

        // 设置个组件的指引值,用作入场动画
        this.swiper.forEach((item, index) => {
          this[item].isActive = this.pageSwiperStore.baseSwiperStore.activeIndex === index;
        });
      },
      [this.pageSwiperStore.baseSwiperStore.activeIndex]
    );

    useEffect(
      () => {
        if (this.appointmentModalStore.isOpen || this.appointmentSuccessModalStore.isOpen || this.isHarmonyDownloadModalOpen) {
          this.pageSwiperStore.stopScroll = true;
        } else {
          this.pageSwiperStore.stopScroll = false;
        }
      },
      [this.appointmentModalStore.isOpen, this.appointmentSuccessModalStore.isOpen, this.isHarmonyDownloadModalOpen]
    );
  }
}

export default MainStore;
